export const POST_CONTACT_DETAILS_REQUEST = 'POST_CONTACT_DETAILS_REQUEST';
export const POST_CONTACT_DETAILS_SUCCESS = 'POST_CONTACT_DETAILS_SUCCESS';
export const POST_CONTACT_DETAILS_FAILURE = 'POST_CONTACT_DETAILS_FAILURE';
export const POST_CONTACT_DETAILS_CLEAR = 'POST_CONTACT_DETAILS_CLEAR';
